export default "__VITE_ASSET__CZLO2DVK__"